import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import AdWrapper from '../../Ads/AdWrapper';
import AboutContent from '../AboutContent';
import SeoURL from './SeoURL';
import CollegeCoachViews from '../CollegeCoachViews';
import LocalizedRankings from '../LocalizedRankings';
import ActivityStatsTeaser from '../ActivityStatsTeaser';

import useIsMobile from '../../hooks/useIsMobile';
import { useAdDynamicConfig } from '../../hooks/useAdDynamicConfig';
import { AdTypes } from '../../../utils/types';
import { useStatsig } from '../../hooks/useStatsig';

function TabContentBase(props) {
    const {
        className,
        displayOnlyMainContent,
        profileData,
        displayCollegeRecruitingValues,
        isUserLoggedIn,
        isOverviewTab,
        onSegmentClick,
        onRankClick,
    } = props;
    const user = useSelector((state) => state.auth?.user);
    const params = useParams();
    const { isMobileWidth } = useIsMobile();
    const { checkGate, featureGates } = useStatsig();
    const { showAds, playerProfileConfig } = useAdDynamicConfig();
    const claimedPlayer = useSelector((state) => state.auth?.user?.claimedPlayer);
    const profileViews = useSelector((state) => state.profile?.profileViews);
    const localizedRankings = useSelector((state) => state.profile?.localizedRankings);

    const showDesktopAds = showAds && !isMobileWidth;
    const showAboutSection = isMobileWidth ? isOverviewTab : true;
    const isCurrentUserProfile = parseInt(params?.playerId) === claimedPlayer?.playerId;
    const showCollegeCoachViews = checkGate(featureGates.COLLEGE_COACH_VIEWS) && isCurrentUserProfile && profileViews?.views?.length > 0;
    const isLocalizedRankingsEnabled = checkGate(featureGates.LOCALIZED_RANKINGS);
    const hasSinglesRankings = localizedRankings?.singlesUtrRankings?.length > 0;
    const hasDoublesRankings = localizedRankings?.doublesUtrRankings?.length > 0;
    const showLocalizedRankings = !!user && (hasSinglesRankings || hasDoublesRankings) && isLocalizedRankingsEnabled && isOverviewTab;
    const isActivityMetricsEnabled = checkGate(featureGates.ACTIVITY_METRICS);
    const showActivityStatsTeaser = isOverviewTab && !!user?.isPowered && isActivityMetricsEnabled;

    return (
        <div className={`tab-content ${className || ''}`}>
            {/* Mobile */}
            <div className={`${displayOnlyMainContent ? 'd-none' : 'd-block d-md-none col-12 col-md-4'}`}>
                {showAboutSection && profileData && (
                    <div>
                        {showLocalizedRankings && <LocalizedRankings onSegmentClick={onSegmentClick} onRankClick={onRankClick} />}
                        {showCollegeCoachViews && <CollegeCoachViews collegeCoachViews={profileViews} />}
                        {showActivityStatsTeaser && (
                            <ActivityStatsTeaser playerId={params?.playerId} isOwnProfile={isCurrentUserProfile} />
                        )}
                        <AboutContent
                            profileData={profileData}
                            displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                            isUserLoggedIn={isUserLoggedIn}
                        />
                        <SeoURL profileData={profileData} />
                    </div>
                )}
            </div>
            {/* Desktop */}
            <div className="container">
                <div className="row">
                    <div className={`${displayOnlyMainContent ? 'col-12' : 'col-12 col-md-8'}`}>
                        {props.children ? props.children : 'No Component Provided'}
                    </div>
                    <div className={`${displayOnlyMainContent ? 'd-none' : 'd-none d-md-block col-12 col-md-4'}`}>
                        {showAboutSection && profileData && (
                            <div>
                                {showLocalizedRankings && <LocalizedRankings onSegmentClick={onSegmentClick} onRankClick={onRankClick} />}
                                {showCollegeCoachViews && <CollegeCoachViews collegeCoachViews={profileViews} />}
                                {showActivityStatsTeaser && (
                                    <ActivityStatsTeaser playerId={params?.playerId} isOwnProfile={isCurrentUserProfile} />
                                )}
                                {showDesktopAds && playerProfileConfig?.showRectangle && (
                                    <div className="d-flex jcc mt24 mb24">
                                        <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="profile.tab-content.ad.rectangle" />
                                    </div>
                                )}
                                <AboutContent
                                    profileData={profileData}
                                    displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                                    isUserLoggedIn={isUserLoggedIn}
                                />
                                <SeoURL profileData={profileData} />
                                {showDesktopAds && playerProfileConfig?.showSkyscraper && (
                                    <div className="d-flex jcc mt24">
                                        <AdWrapper type={AdTypes.SKYSCRAPER_RIGHT} data-testid="profile.tab-content.ad.skyscraper" />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

TabContentBase.propTypes = {
    displayOnlyMainContent: PropTypes.bool,
    displayCollegeRecruitingValues: PropTypes.bool,
    isUserLoggedIn: PropTypes.bool,
    isOverviewTab: PropTypes.bool,
    className: PropTypes.string,
    profileData: PropTypes.objectOf(any),
    children: PropTypes.node,
};

TabContentBase.defaultProps = {
    displayOnlyMainContent: false,
    displayCollegeRecruitingValues: false,
    isUserLoggedIn: false,
    isOverviewTab: false,
    className: '',
    profileData: {},
    children: null,
};

export default TabContentBase;
